module.exports = __webpack_public_path__ + "media/images/categoryIcons/gun_icon-ac1e10ad55c40b97ed9eff9e8b8afd13.svg";